import { Input } from '@mui/material';
import React from 'react';

import { InputRenderer } from '../types';

const HiddenInput = ({ fieldState, inputProps, required }: InputRenderer) => (
  <Input
    error={fieldState?.invalid}
    sx={{
      left: 0,
      width: '1px',
      border: 0,
      height: '1px',
      margin: '.1em',
      padding: 0,
      position: 'absolute',
    }}
    {...inputProps}
    required={required}
    value={inputProps.value ?? ''}
  />
);

export default HiddenInput;
